import { render } from "./BuzzLoginAdmin.vue?vue&type=template&id=159b21f0&scoped=true"
import script from "./BuzzLoginAdmin.vue?vue&type=script&lang=js"
export * from "./BuzzLoginAdmin.vue?vue&type=script&lang=js"

import "./BuzzLoginAdmin.vue?vue&type=style&index=0&id=159b21f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159b21f0"]])

export default __exports__